import React from 'react';
import Summary from './Summary';
import './Summary.scss';

const SummaryContainer = () => {
  return <Summary />;
};

export default SummaryContainer;
